import styled, { css } from "styled-components";
import { HXTextField, multilineEllipsis } from "./base.styles";
import { colors } from "healthex-common/colors";
import { QRCodeCanvas } from "qrcode.react";
import { FlexColumn, FlexColumnDiv, FlexRow } from "./common.styles";
import { HXButton } from "./HXButton";
import { HXAutocomplete } from "./HXAutocomplete";
import { fontWeights } from "healthex-common/weights";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import React from "react";
export const StudyLinkDialogSection = styled(FlexColumn) `
    align-items: center;
    padding: 6px 24px 8px 24px;

    ${(props) => props.width &&
    css `
            width: ${props.width}px;
        `}
`;
export const StudyLinkDialogEnrollmentAndPrescreeningTextContainer = styled(FlexColumnDiv) `
    gap: 8px;
    align-items: flex-start;
`;
export const StudyLinkDialogQRCodeCanvas = styled(QRCodeCanvas) `
    border-radius: 2.4px;
    border: 0.6px solid ${colors.black_12};
`;
export const StudyLinkDialogCopyTextField = styled(HXTextField).attrs({ disabled: true }) `
    align-self: stretch;
    color: ${colors.black_main};

    & textarea,
    input {
        pointer-events: none;
        color: ${colors.black_main} !important;
    }

    &:hover fieldset {
        border-color: ${colors.black_main} !important;
    }

    & .MuiOutlinedInput-root {
        cursor: pointer;
    }

    & .MuiInputBase-input {
        ${multilineEllipsis(1)}
    }

    ${(props) => props.width &&
    css `
            width: ${props.width}px;
            align-self: center;
        `}
`;
export const StudyLinkDialogButtonsContainer = styled(FlexRow) `
    gap: 8px;
    align-items: center;
    align-self: stretch;

    ${(props) => props.justifyContent &&
    css `
            justify-content: ${props.justifyContent};
        `}
`;
export const LeftAlignedButton = styled(HXButton) `
    margin-right: auto;
`;
export const StudyLinkDialogTabAutocomplete = styled(HXAutocomplete).attrs({
    disableClear: true,
    showSelectedValueInOptions: true,
    leftIcon: React.createElement(QrCode2Icon),
}) `
    align-self: stretch;
    margin: 16px 24px 0 24px;
    & .MuiInputBase-input {
        font-weight: ${fontWeights.SEMI_BOLD};
    }
`;
